var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,{tag:"component",attrs:{"payload":_vm.payload}}):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }